import { render, staticRenderFns } from "./mocFacilityRestoration.vue?vue&type=template&id=0c9b9932"
import script from "./mocFacilityRestoration.vue?vue&type=script&lang=js"
export * from "./mocFacilityRestoration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c9b9932')) {
      api.createRecord('0c9b9932', component.options)
    } else {
      api.reload('0c9b9932', component.options)
    }
    module.hot.accept("./mocFacilityRestoration.vue?vue&type=template&id=0c9b9932", function () {
      api.rerender('0c9b9932', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/moc/mocFacilityRestoration.vue"
export default component.exports